import { ToastHorizontalPos, ToastState, ToastVeriticalPos } from '../../types';
import * as types from './types';

export const hideToast = () => {
  return {
    type: types.HIDE_TOAST,
    payload: null,
  };
};

export const showSuccessToast = (values: {
  duration?: number;
  horizontalPos?: ToastHorizontalPos;
  message: string;
  verticalPos?: ToastVeriticalPos;
}): { type: string; payload: ToastState } => {
  return {
    type: types.SHOW_TOAST,
    payload: {
      horizontalPos: values.horizontalPos,
      isVisible: true,
      message: values.message,
      type: 'success',
      verticalPos: values.verticalPos,
    },
  };
};

export const showErrorToast = (values: {
  duration?: number;
  horizontalPos?: ToastHorizontalPos;
  message: string;
  verticalPos?: ToastVeriticalPos;
}): { type: string; payload: ToastState } => {
  return {
    type: types.SHOW_TOAST,
    payload: {
      horizontalPos: values.horizontalPos,
      isVisible: true,
      message: values.message,
      type: 'error',
      verticalPos: values.verticalPos,
    },
  };
};
